
define(
  'ShopByModel.EntryPoint',
  [
    'ShopByModel.List.View'
  ],
  function (
    GoferModelListView
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var pageType = container.getComponent('PageType');

        pageType.registerPageType({
          name: 'gofer-model',
          routes: ['shop-by-model', 'shop-by-model/:machine', 'shop-by-model/:machine?:options'],
          view: GoferModelListView
        });
      }
    };
  }
);
